import { t } from 'i18next';
import type { TablePagination } from './types';

/** The "showing 1–20 of 240" line under a table, or `undefined` when there's nothing to count. */
export function paginationCountsLabel(counts: TablePagination['counts']): string | undefined {
  if (!counts) {
    return undefined;
  }

  return counts.total
    ? t('tables:pagination.counts_with_total', {
        first: counts.first,
        last: counts.last,
        total: counts.total,
      })
    : t('tables:pagination.counts', { first: counts.first, last: counts.last });
}
